import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import getAppConfig from './appConfig';

const baseQuery: ReturnType<typeof fetchBaseQuery> = async (...args) => {
  const { apiHost: baseUrl } = getAppConfig();

  return fetchBaseQuery({
    baseUrl,
    mode: 'cors',
    credentials: 'include',
  })(...args);
};

export const baseApi = createApi({
  reducerPath: 'services',
  baseQuery,
  endpoints: () => ({}),
  // eslint-disable-next-line consistent-return
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
      return action.payload[reducerPath];
    }
  },
});
